export interface IUserExternalSystem {
    code: string;
    name: string;
    externalCode: string;
    inUse: boolean;
}

export class UserExternalSystem implements IUserExternalSystem {
    code: string;
    name: string;
    externalCode: string;
    inUse: boolean;

    constructor();
    constructor(obj: IUserExternalSystem);
    constructor(obj?: any) {
        this.code = obj && obj.code || "";
        this.name = obj && obj.name || "";
        this.externalCode = obj && obj.externalCode || "";
        this.inUse = obj && obj.inUse || false;
    }
}

export class UserSaveExternalSystem {
    code: string;
    externalCode: string;

    constructor();
    constructor(obj: IUserExternalSystem);
    constructor(obj?: any) {
        this.code = obj && obj.code || "";
        this.externalCode = obj && obj.externalCode || "";
    }
}